<div class="content-body">
    <app-breadcrumb [breadcrumb]="breadcrumbList" [addProperty]="checkAddOwner ? 'Add Owner' : ''" (addEvent)="toggleOwner($event)"> </app-breadcrumb>
    <div class="container-fluid">
        <div class="card">
            <div class="card-header display">
                <div class="row align-items-center select2-container">
                    <div class="col-md-6">
                        <h4 class="card-title">Owners</h4>
                    </div>
                    <div class="col-md-6 text-end ">
                        <!-- <a class="btn btn-primary btn-sm me-1" data-bs-toggle="offcanvas" data-bs-target="#owner_add_edit"  href="javascript:void(0);" (click)="toggleOwner()">+ Add Owner</a> -->
                    </div>
                </div>
            </div>
            <div class="card-body p-0">

                <form [formGroup]="searchForm" (ngSubmit)="onSearch()" autocomplete="off">
                <div class="row" *ngIf="searchForm">
                    <div class="col-md-2 mt-3 ps-4">
                        <div class="mb-3">
                            <input type="text" class="form-control input-default search-textbox-height" placeholder="Name" formControlName="search" autocomplete="off"/>
                        </div>
                    </div>
                    <div class="col-md-2 mt-3" *ngIf="checkManagedByFilter">
                        <select2 ngDefaultControl [data]="users" [templates]="template"
                          class="select2" value="" placeholder="Managed by" formControlName="managed_by" (update)="handleSearch('')">
                          <ng-template #template let-data="data">{{data?.name}}</ng-template>
                        </select2>
                    </div>
                    <div class="col-md-2 mt-3">
                        <select2 ngDefaultControl [data]="cities_list" [templates]="template"
                          class="select2" placeholder="Select city" formControlName="city" (update)="handleSearch('')">
                          <ng-template #template let-data="data">{{data?.name}}</ng-template>
                        </select2>
                    </div>
                    <!-- <div class="col-md-2 mt-3">
                        <select2 ngDefaultControl [data]="states_list" [templates]="template"
                          class="select2" placeholder="Select state" formControlName="state" (update)="handleSearch('')">
                          <ng-template #template let-data="data">{{data?.name}}</ng-template>
                        </select2>
                    </div> -->
                    <div class="col-md-3 mt-3">
                        <ng-select [items]="propertiesList" class="select2" bindValue="value" bindLabel="label" placeholder="Select Properties"
                            [typeahead]="searchInput$" [virtualScroll]="true" formControlName="property" (scrollToEnd)="onScrollToEnd()" (change)="handleSearch('')">
                            <!-- <ng-template #template let-data="data">{{data?.name}}</ng-template> -->
                        </ng-select>
                    </div>
                    <!-- <div class="col-md-1 mt-3 p-0">
                        <button class="btn btn-primary btn-sm  float-start" type="submit">Search</button>
                    </div>  -->

                    <div class="col-md-1 mt-3">
                    <button class="btn btn-danger btn-sm  mt-0 float-end"  type="button" (click)="resetSearchForm()" [disabled]="!disableClear">Clear</button>
                    </div>

                    <div class="col-md-2 mt-3">
                        <a class="btn btn-primary btn-sm me-3 mb-3 float-end"  href="javascript:void(0);" (click)="addPropertySearchToggle()">Advanced Search</a>
                    </div>

                    <div #advancedSearchPopup class="offcanvas offcanvas-end customeoff {{ offcanvasSearch ? 'show':''}}" tabindex="-1" id="offcanvasSearch" data-bs-backdrop="static">
                        <div class="offcanvas-header">
                        <h5 class="modal-title" id="#gridSystemModal">Advanced Filter</h5>
                          <button type="button" class="btn-close"  (click)="advancedPropertyClose()">
                              <i class="fa-solid fa-xmark"></i>
                          </button>
                        </div>
                        <div class="offcanvas-body">
                          <div class="container-fluid" >
                            <form [formGroup]="advancedSearchForm" (ngSubmit)="advancedSearch()" autocomplete="off">
                                  <div class="row">
                                      <div class="col-xl-6 mb-3">
                                          <label for="exampleFormControlInput1-1" class="form-label">Address</label>
                                          <input type="text" class="form-control" id="exampleFormControlInput1-1" placeholder="Address" formControlName="address">
                                      </div>
                                      <div class="col-xl-6 mb-3">
                                          <label for="exampleFormControlInput1-2" class="form-label">Contact Number</label>
                                          <input type="text" class="form-control" id="exampleFormControlInput1-2" placeholder="Contact Number" formControlName="phone">
                                      </div>
                                  </div>
                                  <div>
                                      <button class="btn btn-primary ms-1 me-3" type="submit">Search</button>
                                      <button class="btn btn-danger lightme-1" type="button" data-bs-dismiss="offcanvas" aria-label="Close"  (click)="searchClose()">Cancel</button>
                                  </div>
                                </form>
                            </div>
                        </div>
                      </div>
                      @if(offcanvasSearch){
                        <div class="offcanvas-backdrop fade show" (click)="advancedPropertyClose()"></div>
                    }
                </div>
            </form>

            <ng-template #content let-modal>
                <div class="modal-header">
                  <h5 class="modal-title">Other Properties</h5>
                  <button type="button" class="btn-close" (click)="closeModal()"></button>
                </div>
                <div class="modal-body d-flex flex-column align-items-center">
                    <div *ngFor="let property of itemDetails; let i = index">
                        <span class="badge badge-info light border-0 m-1 w-100 c-pointer" *ngIf="i !==0" (click)="redirectToProperty(property.uid)">
                            {{ property.name }}
                        </span>
                    </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" (click)="closeModal()">Close</button>
                </div>
              </ng-template>

                    <div class="row">
                        <div class="col-xl-12">
                        <div class="table-responsive active-projects style-1 ItemsCheckboxSec shorting dataTables_wrapper">
                            <table  id="empoloyees-tbl" class="table mb-0" matSort (matSortChange)="sortData($event)">
                                <thead>
                                    <tr>
                                        <th>Join Date</th>
                                        <th mat-sort-header="first_name">First name</th>
                                        <th mat-sort-header="last_name">Last Name</th>
                                        <th mat-sort-header="email">Email</th>
                                        <th>Property</th>
                                        <th>Active</th>
                                        <th class="text-center">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    @for(item of allData.data; track item.uid){
                                    <tr>
                                        <td>{{ item.created_at | date: 'dd-MM-yyyy' }}</td>
                                        <td>{{ item.first_name }}</td>
                                        <td>
                                            <span>{{ item.last_name }}</span>
                                        </td>
                                        <td>{{ item.email }}</td>
                                        <td>
                                            <div (click)="redirectToProperty(item.properties?.[0]?.uid)" class="highlight-property">
                                                {{ item.properties.length ? item.properties[0].name : "" }}
                                            </div>
                                            <a *ngIf="item.properties?.length > 1" href="javascript:void(0)" (click)="openCenter(content, item.properties)" class="badge badge-sm light badge-secondary me-2 mt-1">View More</a>
                                        </td>
                                        <td>{{ item.is_active ? 'Yes' : 'No' }}</td>
                                        <td class="text-center">
                                            <button *ngIf="checkViewOwner" type="button" class="btn btn-success shadow btn-xs sharp mb-1 me-2" (click)="viewOwner(item.uid)"><i class="fa fa-eye"></i></button>
                                             <button *ngIf="checkDeleteOwner" type="button" class="btn btn-danger shadow btn-xs sharp mb-1" (click)="deleteUser(item.uid)"><i class="fa fa-trash"></i></button>
                                        </td>
                                    </tr>
                                    }
                                </tbody>
                            </table>
                            <div class="dataTables_info" id="example5_info" role="status" aria-live="polite" *ngIf="allData.data?.length">Showing {{allData.startPage}} to
                            {{allData.endPage}} of {{ totalPage }} entries
                        </div>
                            <div class="dataTables_paginate paging_simple_numbers pt-2">
                                <app-pagination [totalPage]="pageCount" [page]="page" (newPage)="pageChange($event)"></app-pagination>
                            </div>
                        </div>




                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-owner-add (addOwnerEvent)="addOwner($event)"></app-owner-add>
